<template>
  <v-row justify="center" class="mt-4">
    <v-col cols="10" md="4" class="center">
      <v-card>
        <v-card-title class="justify-center"
          ><h3>Iniciar Sesión</h3>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row justify="center">
              <v-col cols="10">
                <v-text-field
                  v-model="correoElectronico"
                  :rules="[Validaciones.requerido]"
                  label="Nombre de Usuario"
                  dense
                  required
                  outlined
                  @input="resetearContador"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="10">
                <v-text-field
                  v-model="password"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[Validaciones.requerido, Validaciones.min]"
                  :type="show1 ? 'text' : 'password'"
                  name="input-10-1"
                  label="Contraseña"
                  hint="Minimo 6 Caracteres"
                  counter
                  dense
                  outlined
                  @click:append="show1 = !show1"
                  @keydown.enter="tipoSesion()"
                  @input="resetearContador"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-card-text justify="center">
              <v-row justify="center" class="mb-2">
                <v-btn
                  color="primary"
                  @click="tipoSesion()"
                  :loading="loadingButton"
                >
                  Iniciar Sesion
                </v-btn>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>

    <v-snackbar v-model="Showsnackbar" top :color="colorSnack">
      {{ mensajeSnack }}

      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="Showsnackbar = false"
          :loading="loadingButton"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
    <!-- <dialog-mensaje ref="dialogMensaje" @resultado="confirmarOperacion" /> -->
    <dialog-login ref="dialogLogin" @resultado="confirmarOperacion" />
  </v-row>
</template>

<script>
import axios from "axios";
//import dialogMensaje from "@/components/modalMensaje.vue";
import dialogLogin from "@/components/modalLogin.vue";
// import qs from "qs";
import sha512 from "js-sha512";
export default {
  components: {
    //dialogMensaje,
    dialogLogin,
  },
  data: () => ({
    url: null,
    cantidadIntentos: 0,
    isOnline: navigator.onLine,
    mensajeSnack: "",
    Showsnackbar: false,
    colorSnack: "green",
    loadingButton: false,
    valid: false,
    correoElectronico: "",
    password: "",
    show1: false,
    respuesta: null,
    textoSwitch: "Usuario Operador",
    SeleccionLogueo: true,
    disableColor: false,
    iconoSwitch: "mdi-home-account",

    // append-icon="mdi-truck-check"
    //           prepend-icon="mdi-account-lock"

    Validaciones: {
      requerido: (v) => !!v || "Campo Requerido",
      emailRules:
        // v => !!v || 'E-mail is required',
        (v) => /.+@+.+.com+/.test(v) || "E-mail debe ser valido",
      // dni: (v) => {
      //   return !!v && v.toString().length >= 7 && v.toString().length <= 8
      //     ? true
      //     : "DNI Invalido";
      // },
      min: (v) => v.length >= 6 || "Minimo 6 caracteres",
      // cuit: (v) => {
      //   return !!v && v.toString().length >= 10 && v.toString().length <= 11
      //     ? true
      //     : "CUIT Invalido";
      // },
    },
  }),
  mounted() {
    // this.$store.commit(
    //   "actualizarUrlBase",
    //   "http://sistemadetareasapi.edese.local/api/"
    // );
    //this.$store.commit("actualizarUrlBase", "https://localhost:5001/api/");
    this.url = process.env.VUE_APP_URL_BASE;

    console.log("La variable de usuario es:");
    console.log("Login de la pagina");
    console.log(this.$store.getters.usuario.user_name);
    //this.$store.commit("actualizarUrlBase", "https://localhost:5001/api/");
  },

  created() {
    // Agrega un listener para el evento online/offline
    window.addEventListener("online", this.handleConnectionChange);
    window.addEventListener("offline", this.handleConnectionChange);
  },
  beforeDestroy() {
    // Elimina los listeners del evento online/offline para evitar pérdidas de memoria
    window.removeEventListener("online", this.handleConnectionChange);
    window.removeEventListener("offline", this.handleConnectionChange);
  },
  methods: {
    resetearContador() {
      this.cantidadIntentos = 0;
    },
    handleConnectionChange() {
      this.isOnline = navigator.onLine;
      console.log("La conexion es: ");
      console.log(this.isOnline);
    },
    tipoSesion() {
      this.$store.commit("actualizarUrlBase", this.url);
      // this.$store.commit(
      //   "actualizarUrlBase",
      //   "https://apigateway.edesesa.com.ar/tareas/"
      // );
      // this.$store.commit(
      //   "actualizarUrlBase",
      //   "http://sistemadetareasapi.edese.local/api/"
      // );
      if (this.SeleccionLogueo == true) this.IniciarSesionEncode();
      else this.IniciarSesionEncode_Gang();
    },
    isMobile() {
      if (screen.width <= 760) {
        this.SeleccionLogueo = false;
      } else {
        this.SeleccionLogueo = true;
      }
    },
    async confirmarOperacion(respuesta) {
      this.loadingButton = false;
      //this.ingresarComo(respuesta);
      //console.log("El id rol seleccionado es");
      //console.log(respuesta);
      this.$store.getters.usuario.idRol = respuesta;
      this.$store.dispatch("agregarEmailAction", this.$store.getters.usuario);
      this.$router.push("/Principal");
    },
    reintentarLogin() {
      this.IniciarSesionEncode();
    },
    async IniciarSesionEncode() {
      console.log("Inicio la sesion");
      if (this.$refs.form.validate()) {
        this.loadingButton = true;
        this.url = this.$store.getters.urlBase + "Usuarios/login";
        const data = {
          userLogin: this.correoElectronico,
          password: sha512(this.password),
        };

        //console.log("URLBase Login");
        //console.log(this.url);

        await axios
          .post(this.url, data)
          .then((response) => {
            this.respuesta = response;
            console.log("Exito");
          })
          .catch((error) => {
            this.cantidadIntentos = this.cantidadIntentos + 1;

            //console.log("Ingreso en el catch");
            //console.log("El error es: ");
            //console.log(error);
            //console.log(this.cantidadIntentos);

            //console.log("LA direccion antes de ser cambiada es: ");
            //console.log(this.url);

            this.$store.commit(
              "actualizarUrlBase",
              "http://sistemadetareasapi.edese.local/api/"
            );

            //console.log("LA direccion despues de ser cambiada es: ");
            //console.log(this.url);

            if (this.cantidadIntentos < 2) {
              this.reintentarLogin();
            }
            // this.$store.getters.urlBase =
            //   "https:/apigateway.edesesa.com.ar/tareas/";

            if (this.cantidadIntentos >= 2) {
              if (error.response) {
                this.mensajeSnack = error.response.data;
              } else {
                this.mensajeSnack = "Error de Conexion";
              }
              this.colorSnack = "red";
              this.Showsnackbar = true;
            }
          });

        this.loadingButton = false;
        //console.log("Los datos del login son: ");
        //console.log(this.respuesta.data);
        if (this.respuesta.status === 200) {
          var actualUser = {
            user_id: this.respuesta.data.id,
            user_name: this.respuesta.data.userLogin,
            token: this.respuesta.data.token,
            idRol: this.respuesta.data.idRol,
            idContratista: this.respuesta.data.idContratista,
            idCuadrilla: this.respuesta.data.idCuadrilla,
            idDistrito: this.respuesta.data.idDistrito,
            expiration: this.respuesta.data.expiration,
          };
          this.$store.dispatch("agregarEmailAction", actualUser);
          //console.log("Los datos del usuario son: ");
          //console.log(this.$store.getters.usuario);
          //console.log("fecha expiracion");
          //console.log(
          //  this.moment(actualUser.expiration).format("YYYY-MM-DD HH:mm:ss")
          //);

          // if (this.$store.getters.usuario.idRol == 5) {
          //   this.$refs.dialogLogin.abrirMensajeDialog(
          //     "Seleccione el tipo de cuenta para iniciar sesion",
          //     1,
          //     "blue",
          //     "Confirmacion"
          //   );
          // } else {
          //   this.$router.push("/Principal");
          // }

          this.$router.push("/Principal");
        } else {
          // this.$store.commit(
          //   "actualizarUrlBase",
          //   "https:/apigateway.edesesa.com.ar/tareas/"
          // );
          // this.reintentarLogin();
        }
      }
    },
    async IniciarSesionEncode_Gang() {
      if (this.$refs.form.validate()) {
        this.loadingButton = true;
        this.url = this.$store.getters.urlBase + "Usuarios/loginGang";
        const data = {
          userLogin: this.correoElectronico,
          password: sha512(this.password),
        };

        await axios
          .post(this.url, data)
          .then((response) => (this.respuesta = response))
          .catch((error) => {
            if (error.response) {
              this.mensajeSnack = error.response.data;
            } else {
              this.mensajeSnack = "Error de Conexion";
            }
            this.colorSnack = "red";
            this.Showsnackbar = true;
          });

        this.loadingButton = false;
        // console.log(this.respuesta);
        if (this.respuesta.status === 200) {
          var actualUser = {
            user_id: this.respuesta.data.id,
            user_name: this.respuesta.data.email,
            token: this.respuesta.data.token,
            expiration: this.respuesta.data.expiration,
            rol: this.respuesta.data.rol,
          };
          this.$store.dispatch("agregarEmailAction", actualUser);
          //console.log(this.$store.getters.usuario);
          // console.log("fecha expiracion");
          //console.log(
          //  this.moment(actualUser.expiration).format("YYYY-MM-DD HH:mm:ss")
          //);
          this.$router.push("/Principal");
        }
      }
    },
  },
  watch: {
    SeleccionLogueo() {
      if (this.SeleccionLogueo == true) {
        this.textoSwitch = "Usuario Operador";
        this.iconoSwitch = "mdi-home-account";
        this.disableColor = false;
      } else {
        this.textoSwitch = "Usuario Cuadrilla";
        this.iconoSwitch = "mdi-truck";
        this.disableColor = true;
      }
    },
  },
};
</script>
<!-- <style>
  .input__label {
    color: {{colorswitch}};
  }
</style> -->
